(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelDocumentation',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$form.on('change', '[name="form_component_data[TravelDocumentation][country_of_citizenship]"]', function toggleCitizenshipText() {
			$('#traveldocumentation-citizenship_text').toggleClass('hidden', this.value !== 'other');
		});
	};

}(jQuery, window.Adzuki || {}));
